import { RightOutlined, LoadingOutlined } from "@ant-design/icons";
import {

  Row,
  Col,

  Button,

  Form,
  Input,

  Select,

  Radio,

  Space,
  Spin,


} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';

import accountService from "../../../api/account.service";
import { addAccountGroup } from "../../../store/accountGroupSlice";




import { EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";

import CustomMessage from "../../common/CustomMessage";
const { Option } = Select;



const AccountGroupEntry = ({ data, onDrawerClose }) => {
  const dispatch = useDispatch();
  // console.log(data)

  const [isPageLoading, setIsPageLoading] = useState(true);

  const [isFormResponse, setIsFormResponse] = useState(false);
  const [formResponseMessage, setFormResponseMessage] = useState("");
  const [formResponseStatus, setFormResponseStatus] = useState("");

  const [topGroupParentId, setTopGroupParentId] = useState('');
  const [accMainCategory, setAccMainMainCategory] = useState('');
  const [accSubCategory, setAccSubCategory] = useState('');

  const [isSaveLoaderEnable, setIsSaveLoaderEnable] = useState(false);



  const handlePageLoading = () => {
    alert("artyp")

    setIsPageLoading(true);
  }



  const [formDefaultValues, setFormDefaultValues] = useState({
    group_id: data.group_id,
    group_description: data.group_description,
    main_category: data.main_category,
    sub_category: data.sub_category,
    group_alias: data.group_alias,
    is_bank: data.is_bank,
    group_parent_id: data.group_parent_id,
    is_parent: data.is_parent,
    is_active: data.is_active,
    mode: data.mode
  });


  const [accountGroupList, setAccountGroupList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  //const [isParentChecked, setIsParentChecked] = useState(formDefaultValues.group_parent_id > 0 ? false : true);
  const [isParentChecked, setIsParentChecked] = useState(formDefaultValues.is_parent == "Y" ? true : false);

  const [isParentYesValidationRequired, setIsParentYesValidationRequired] = useState(formDefaultValues.is_parent == "Y" ? true : false);
  const [isParentNoValidationRequired, setIsParentNoValidationRequired] = useState(formDefaultValues.is_parent == "N" ? true : false);

  const [mode, setMode] = useState(data.mode);


  const [form] = Form.useForm();

  const onAccountGroupSave = async (values) => {

    setIsSaveLoaderEnable(true)
    //   console.log(values);
    const data = { formdata: values };

    const response = accountService.accountGroupSave(data).then((resdata) => {

      setIsFormResponse(true);
      setFormResponseStatus(resdata.response_status);
      setFormResponseMessage(resdata.response_msg);

      let x = {
        group_id: 10 + Math.random() * (1000 - 10),
        group_description: values.group_description
      }
      dispatch(addAccountGroup(x))
      setIsSaveLoaderEnable(false)

    });


  };



  const onIsParentChange = ({ target: { value } }) => {
    //value == "Y" ? setIsParentChecked(true) : setIsParentChecked(false);

    if (value == "Y") {
      setIsParentChecked(true)
      setIsParentYesValidationRequired(true)
      setIsParentNoValidationRequired(false)
    }
    else {
      setIsParentChecked(false)
      setIsParentNoValidationRequired(true)
      setIsParentYesValidationRequired(false)
    }


    form.setFieldsValue({
      main_category: '',
      sub_category: '',
      group_parent_id: null,
      top_parent_id: 0
    });
  };


  useEffect(() => {
    if (!isParentChecked) {
      form.setFieldsValue({
        main_category: '',
        sub_category: '',
        group_parent_id: null,
        top_parent_id: 0
      });
    }

  }, []);


  const hideResponseMessage = () => {
    setIsFormResponse(false);
    if (mode == "ADD") {
      form.resetFields();
      form.setFieldsValue({
        group_id: formDefaultValues.group_id,
        mode: formDefaultValues.mode,
        is_bank: 'N',
        group_parent_id: null,
        is_active: "Y",
        is_parent: formDefaultValues.is_parent,
      })
    }
  }


  const onSelectMainCategory = (value, event) => {
    form.setFieldsValue({
      group_parent_id: null,
      sub_category: ''
    });
    const data = { formdata: { category: value } };
    accountService.subCategoryByCategoryList(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setSubCategoryList(res.data.response_data);
      }

    });
  }

  const onParentGroupChange = (value, event) => {
    if (!isParentChecked) {
      const data = { formdata: { group_id: value } };

      accountService.accountGroupTopParent(data).then((res) => {

        if (res.data.response_status === SUCCESS_STATUS && res.data.response_data.length > 0) {
          const res_data = res.data.response_data[0];
          setTopGroupParentId(res_data.top_parent_id)
          setAccMainMainCategory("")
          setAccSubCategory("")

          form.setFieldsValue({
            top_parent_id: res_data.top_parent_id,
            main_category: res_data.main_category,
            sub_category: res_data.sub_category,
          });

        }

      });
    }
  }

  useEffect(() => {
    console.log("After Save", mode)
    mode == EDIT_MODE ?

      form.setFieldsValue({
        //group_id: formDefaultValues.component_id,
        group_id: formDefaultValues.group_id,
        group_description: formDefaultValues.group_description,
        main_category: formDefaultValues.main_category,
        sub_category: formDefaultValues.sub_category,
        group_alias: formDefaultValues.group_alias,
        is_bank: formDefaultValues.is_bank,
        group_parent_id: formDefaultValues.group_parent_id,
        is_active: formDefaultValues.is_active,
        is_parent: formDefaultValues.is_parent,
        mode: formDefaultValues.mode

      })
      :
      form.setFieldsValue({
        group_id: 0,
        group_description: '',
        main_category: '',
        sub_category: '',
        group_alias: '',
        is_bank: 'N',
        group_parent_id: null,
        is_active: "Y",
        is_parent: formDefaultValues.is_parent,
        mode: data.mode
      });

    form.setFieldsValue(formDefaultValues)

  }, [form]);



  useEffect(() => {
    accountService.accountGroupList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setAccountGroupList(res.data.response_data);
      }

    });
  }, []);


  useEffect(() => {
    const data = { formdata: { category: form.getFieldValue('main_category') } };
    accountService.subCategoryByCategoryList(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setSubCategoryList(res.data.response_data);
      }

    });
  }, [])


  useEffect(() => {


    const data = { formdata: { group_id: form.getFieldValue('group_parent_id') } };
    console.log("fafafafs", data);
    accountService.accountGroupTopParent(data).then((res) => {

      if (res.data.response_status === SUCCESS_STATUS && res.data.response_data.length) {
        const res_data = res.data.response_data[0];
        form.setFieldsValue({
          top_parent_id: res_data.top_parent_id,
          main_category: res_data.main_category,
          sub_category: res_data.sub_category,
        });
      }
    });


  }, [])


  useEffect(() => {
    console.log("gggfffrererere")
    window.addEventListener("load", handlePageLoading);
    return () => window.removeEventListener("load", handlePageLoading);
  }, [])


  return (
    <div>
      <div className="form-input-style">

        <Row className="" style={{ background: "transparent" }}>
          <Col className="" xs={24} xl={24}>
            <Form
              form={form}
              layout="vertical"
              onFinish={onAccountGroupSave}
              autoComplete="off"
            // initialValues={formDefaultValues}
            >

              {/* <Row gutter={20}>
                            <Col className="gutter-row" xs={24} xl={24}>
                                <h5>Note: * fields are required</h5>
                            </Col>
                        </Row> */}
              <Row gutter={20}>
                <Col className="gutter-row" xs={24} xl={24}>

                  <Form.Item name="group_description" label="Group" rules={[
                    {
                      required: true,
                      message: 'Group is required',
                    },
                  ]}>
                    <Input placeholder="" size="large" />
                  </Form.Item>
                  <Form.Item name="group_id" label="group_id" hidden={true}>
                    <Input type="text" />
                  </Form.Item>
                  <Form.Item name="mode" label="mode" hidden={true}>
                    <Input type="text" />
                  </Form.Item>
                  <Form.Item name="top_parent_id" label="top_parent_id" hidden={true}>
                    <Input type="text" />
                  </Form.Item>

                </Col>
                <Col xs={24} xl={12}>
                  <Form.Item name="is_parent" label="Is Parent" rules={[
                    {
                      required: true,
                      message: 'Select Parent or not',
                    },
                  ]}>
                    <Radio.Group
                      onChange={onIsParentChange}
                      defaultValue="N"
                      style={{ width: "100%" }}
                      optionType="button"
                      buttonStyle="solid"
                    >
                      <Radio.Button value="Y">Yes</Radio.Button>
                      <Radio.Button value="N">No</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>


                <Col xs={24} xl={12} style={{ display: isParentChecked ? 'block' : 'none' }}>
                  <Form.Item name="main_category" label="Main Account" rules={[
                    {
                      required: isParentYesValidationRequired,
                      message: 'Select main account',
                    },
                  ]} >
                    <Select className="text-left" onSelect={(value, event) => onSelectMainCategory(value, event)} allowClear={true} >
                      {/* <Option value="">Select</Option> */}
                      <Option value="B">Balance Sheet</Option>
                      <Option value="P">Income & Expenditure</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12} style={{ display: isParentChecked ? 'block' : 'none' }}>
                  <Form.Item name="sub_category" label="Sub Group" rules={[
                    {
                      required: isParentYesValidationRequired,
                      message: 'Select sub group',
                    },
                  ]}>
                    <Select className="text-left" defaultValue="Select" allowClear={true} >
                      {/* <Option value="">Select</Option> */}
                      {
                        subCategoryList.length > 0 ?
                          subCategoryList.map(sub_category => (
                            <Option key={sub_category.key} value={sub_category.key}>{sub_category.value}</Option>

                          ))
                          : ''
                      }
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12} style={{ display: !isParentChecked ? 'block' : 'none' }}>
                  <Form.Item name="group_parent_id" label="Parent Group" rules={[
                    {
                      required: isParentNoValidationRequired,
                      message: 'Select parent Group',
                    },
                  ]}>
                    <Select className="text-left" 
                    showSearch
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        //option.children.includes(input)
                        option.children.toLowerCase().includes(input.toLowerCase())
                    }
                    filterSort={(optionA, optionB) =>
                        optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                    }
                    onSelect={(value, event) => onParentGroupChange(value, event)} 
                    allowClear={true}
                     >
                      {
                        accountGroupList.length > 0 ?
                          accountGroupList.map(account_group => (
                            <Option key={account_group.group_id} value={account_group.group_id}>{account_group.group_description}</Option>

                          ))
                          : ''
                      }
                    </Select>
                  </Form.Item>
                </Col>



                <Col xs={24} xl={12} hidden={true}>
                  <Form.Item name="is_bank" label="Bank">
                    <Radio.Group
                      defaultValue="N"
                      style={{ width: "100%" }}
                      optionType="button"
                      buttonStyle="solid"
                    >
                      <Radio.Button value="Y">Yes</Radio.Button>
                      <Radio.Button value="N">No</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} xl={12}>
                  <Form.Item name="is_active" label="Active">
                    <Radio.Group
                      defaultValue="Y"
                      style={{ width: "100%" }}
                      optionType="button"
                      buttonStyle="solid"
                    >
                      <Radio.Button value="Y">Yes</Radio.Button>
                      <Radio.Button value="N">No</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item name="" label=" ">
                    <Space>

                      {
                        isSaveLoaderEnable ? <> <Spin indicator={commonUtility.antIcon} /></> : <><Button className="custom-button-green" htmlType="submit">
                          Save <RightOutlined />
                        </Button></>
                      }



                    </Space>
                  </Form.Item>
                </Col>


              </Row>
            </Form>



          </Col>
        </Row>
        {
          isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
        }




      </div>
    </div>
  )




};

export default AccountGroupEntry;
